import { createTheme } from "@mui/material/styles";

const primaryColor = process.env.REACT_APP_BRAND_PRIMARY_COLOR || "#1d3d7c";

const theme = createTheme({
    palette: {
        primary: {
          main: primaryColor,
        },
        text:{
          primary: "#333"
        }
    }
  });

export default theme;